export default function TwitterSvg() {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_232_7254)'>
        <path d='M0 0H24V24H0V0Z' fill='#1DA1F2' />
        <path
          d='M13.998 5.98868C13.3537 6.33204 12.838 6.87509 12.5285 7.53636C12.219 8.19762 12.1322 8.94143 12.2813 9.65618C9.65626 9.51518 7.12501 8.29643 5.48401 6.18743C5.26077 6.54399 5.11032 6.94121 5.04133 7.35619C4.97234 7.77117 4.98618 8.1957 5.08204 8.60531C5.17791 9.01492 5.35391 9.4015 5.59989 9.74276C5.84587 10.084 6.15697 10.3732 6.51526 10.5937C6.00001 10.5937 5.48476 10.4999 5.01526 10.2652C5.06251 11.8124 6.14026 13.1722 7.64026 13.4999C7.17226 13.6409 6.65626 13.6409 6.14026 13.5472C6.60976 14.9062 7.87501 15.8437 9.28126 15.8909C7.92151 17.0159 6.09376 17.5312 4.35901 17.2499C5.8084 18.217 7.49969 18.7589 9.24124 18.814C10.9828 18.8692 12.705 18.4355 14.2127 17.5621C15.7204 16.6887 16.9533 15.4105 17.7718 13.8723C18.5903 12.3341 18.9617 10.5974 18.8438 8.85893C19.5 8.39093 20.0625 7.82843 20.4848 7.12493C19.9223 7.40618 19.266 7.59368 18.6098 7.68743C19.3125 7.26518 19.8285 6.60893 20.1098 5.81243C19.4535 6.18743 18.75 6.46868 18 6.60968C17.4899 6.08716 16.8241 5.74417 16.1025 5.6322C15.3809 5.52023 14.6425 5.64532 13.998 5.98868Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_232_7254'>
          <rect fill='white' height='24' rx='4' width='24' />
        </clipPath>
      </defs>
    </svg>
  )
}
